import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import { ProtectedRoute } from "@/lib/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Deposit from "@/pages/Deposit";
import Funding from "@/pages/Funding";
import Rewards from "@/pages/Rewards";
import Withdrawals from "@/pages/Withdrawals";
import Support from "@/pages/Support";
import Announcements from "@/pages/Announcements";
import WalletPage from "@/pages/WalletPage";
import Profile from "@/pages/Profile";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminDeposits from "@/pages/admin/AdminDeposits";
import AdminWithdrawals from "@/pages/admin/AdminWithdrawals";
import AdminTickets from "@/pages/admin/AdminTickets";
import AdminAnnouncements from "@/pages/admin/AdminAnnouncements";
import AdminSettings from "@/pages/admin/AdminSettings";

import AppLayout from "@/components/AppLayout";
import { Loader } from "@/components/Loader";

function UserShell({ children }) {
  return <AppLayout admin={false}>{children}</AppLayout>;
}
function AdminShell({ children }) {
  return <AppLayout admin={true}>{children}</AppLayout>;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Landing />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  return <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/register" element={<Register />} />

          {/* User */}
          <Route path="/dashboard" element={<ProtectedRoute><UserShell><Dashboard /></UserShell></ProtectedRoute>} />
          <Route path="/deposit" element={<ProtectedRoute><UserShell><Deposit /></UserShell></ProtectedRoute>} />
          <Route path="/funding" element={<ProtectedRoute><UserShell><Funding /></UserShell></ProtectedRoute>} />
          <Route path="/rewards" element={<ProtectedRoute><UserShell><Rewards /></UserShell></ProtectedRoute>} />
          <Route path="/withdrawals" element={<ProtectedRoute><UserShell><Withdrawals /></UserShell></ProtectedRoute>} />
          <Route path="/wallet" element={<ProtectedRoute><UserShell><WalletPage /></UserShell></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><UserShell><Profile /></UserShell></ProtectedRoute>} />
          <Route path="/support" element={<ProtectedRoute><UserShell><Support /></UserShell></ProtectedRoute>} />
          <Route path="/announcements" element={<ProtectedRoute><UserShell><Announcements /></UserShell></ProtectedRoute>} />

          {/* Admin */}
          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminShell><AdminDashboard /></AdminShell></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute adminOnly><AdminShell><AdminUsers /></AdminShell></ProtectedRoute>} />
          <Route path="/admin/deposits" element={<ProtectedRoute adminOnly><AdminShell><AdminDeposits /></AdminShell></ProtectedRoute>} />
          <Route path="/admin/withdrawals" element={<ProtectedRoute adminOnly><AdminShell><AdminWithdrawals /></AdminShell></ProtectedRoute>} />
          <Route path="/admin/tickets" element={<ProtectedRoute adminOnly><AdminShell><AdminTickets /></AdminShell></ProtectedRoute>} />
          <Route path="/admin/announcements" element={<ProtectedRoute adminOnly><AdminShell><AdminAnnouncements /></AdminShell></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute adminOnly><AdminShell><AdminSettings /></AdminShell></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
